module.exports = __webpack_public_path__ + "img/Liefervampir.ea8b7e71.jpg";